<template>
  <div>
    <v-dialog
      v-model="dialogCharities"
      width="500"
      overlay-opacity="0.2"
      class="rounded-xl"
    >
      <v-card class="pb-6 rounded-xl" min-height="600">
        <v-card-title class="headline white--text primary" primary-title>
          {{ $t("dialogCharities.charities") }}
          <v-spacer></v-spacer>
          <v-btn
            v-if="$vuetify.breakpoint.smAndDown"
            icon
            dark
            @click="dialogCharities = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <transition-group name="list-complete">
          <v-card
            flat
            v-for="(charity, index) in charities"
            :key="index"
            class="list-complete-item mx-6 mt-6 mb-2 rounded-lg"
            :href="charity.facebook"
            target="_blank"
            height="200"
          >
            <v-row no-gutters>
              <v-img
                :src="charity.bannerUrl"
                class="primary rounded-lg"
                height="200"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-row>
            <v-row no-gutters style="margin-top: -90px; margin-left: 20px">
              <v-img
                class="shrink d-flex rounded-lg align-center"
                style="background-color: var(--v-primary-base); z-index: 3"
                :src="charity.logoUrl"
                width="70"
                height="70"
                ><template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-row>
            <div
              class="text-h5 white--text mb-0"
              style="
                position: absolute;
                bottom: 0;
                right: 0;
                left: 0;
                height:100px
                text-shadow: 0px 3px 10px #000;
                padding-left: 106px;
                padding-top: 30px;
                background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
              "
            >
              {{ charity.name }}
            </div>
          </v-card>
        </transition-group>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      charities: [
        {
          name: "Trash Hero",
          bannerUrl: "https://i.imgur.com/zLk2Y4y.jpg",
          logoUrl: "https://i.imgur.com/6THj52A.jpg",
          facebook: "https://www.facebook.com/TrashHeroHCM",
        },
        {
          name: "Hành Trình Gom",
          bannerUrl: "https://i.imgur.com/9mczXRf.jpg",
          logoUrl: "https://i.imgur.com/THvJnEG.jpg",
          facebook: "https://www.facebook.com/hanhtrinhgom",
        },
        {
          name: "Plastic People",
          bannerUrl: "https://i.imgur.com/8JgAizZ.jpg",
          logoUrl: "https://i.imgur.com/oyENEjC.png",
          facebook: "https://www.facebook.com/WeArePLASTICPeople",
        },
        {
          name: "Plastic Please",
          bannerUrl: "https://i.imgur.com/oBrgboN.jpg",
          logoUrl: "https://i.imgur.com/HgrZVvM.jpg",
          facebook: "https://www.facebook.com/plasticpleasesaigon",
        },
      ],
    };
  },
  computed: {
    dialogCharities: {
      get() {
        return this.$store.state.dialogCharities;
      },
      set(val) {
        return this.$store.commit("setDialogCharities", val);
      },
    },
  },
};
</script>

<style>
/* transition list */
.list-complete-item {
  transition: all 0.5s;
}
.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
.list-complete-leave-active {
  position: absolute;
  z-index: -1;
}
</style>